var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePayTypeface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15.8562,
    height: 10.3225,
    viewBox: "0 0 15.8562 10.3225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pay_Typeface_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Letter_p_3_",
    d: "M1.02128 4.72297V7.93714H0V0H2.70745C3.39362 0 3.97872 0.228446 4.45745 0.685336C4.94681 1.14223 5.19149 1.70006 5.19149 2.35883C5.19149 3.03354 4.94681 3.59137 4.45745 4.04295C3.98404 4.49452 3.39894 4.71766 2.70745 4.71766H1.02128V4.72297ZM1.02128 0.977533V3.74544H2.72872C3.13298 3.74544 3.47341 3.60731 3.73936 3.33636C4.01064 3.06541 4.14893 2.73603 4.14893 2.36414C4.14893 1.99757 4.01064 1.67349 3.73936 1.40255C3.47341 1.12098 3.1383 0.982845 2.72872 0.982845H1.02128V0.977533Z",
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Letter_a_3_",
    d: "M7.86119 2.3269C8.61651 2.3269 9.21225 2.52879 9.64842 2.93255C10.0846 3.33631 10.3027 3.88883 10.3027 4.5901V7.93709H9.32927V7.18269H9.28672C8.86651 7.80427 8.30268 8.11241 7.60055 8.11241C6.99949 8.11241 6.49949 7.93709 6.09523 7.58114C5.69098 7.22519 5.48885 6.78424 5.48885 6.25297C5.48885 5.68983 5.70161 5.24356 6.12715 4.91418C6.55268 4.57948 7.12183 4.41478 7.82927 4.41478C8.43566 4.41478 8.93566 4.52635 9.32396 4.74948V4.51573C9.32396 4.15978 9.18566 3.86227 8.90374 3.61257C8.62183 3.36287 8.29204 3.24068 7.91438 3.24068C7.34523 3.24068 6.8931 3.47975 6.56332 3.96321L5.66438 3.40006C6.15906 2.68285 6.8931 2.3269 7.86119 2.3269ZM6.54204 6.26891C6.54204 6.53454 6.65374 6.75767 6.88247 6.93299C7.10587 7.10831 7.37183 7.19863 7.67502 7.19863C8.10587 7.19863 8.48885 7.03925 8.82395 6.72049C9.15906 6.40172 9.32927 6.02984 9.32927 5.59951C9.01012 5.34982 8.56864 5.22231 7.99949 5.22231C7.58459 5.22231 7.23885 5.32325 6.96225 5.51982C6.68034 5.72702 6.54204 5.97671 6.54204 6.26891Z",
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Letter_y_3_",
    d: "M15.8562 2.5022L12.4519 10.3225H11.3987L12.6647 7.58643L10.42 2.5022H11.5317L13.1487 6.4017H13.17L14.7445 2.5022H15.8562Z",
    fill: "#3C4043"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayTypeface);
export default __webpack_public_path__ + "static/media/google-pay-typeface.9e4910ebe29ad923de78aeeda1c90423.svg";
export { ForwardRef as ReactComponent };